<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-23 14:29:27
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/components/AzServices/index.vue
-->
<template>
  <div class="service_all">
    <div class="top_info">
      <div class="info_title font14 font_weight500 colo0 text_left">
        平台服务
      </div>
    </div>
    <div class="service_list">
      <div class="list_item" @click="goService">
        <img src="@/assets/mine/icon_kehu@2x.png" alt="" class="icon_img" />
        <div class="font14 font_weight500 colo0">客户服务</div>
      </div>
      <template v-if="$appSource != 3">
        <div class="list_item" @click="showToast">
          <img src="@/assets/mine/icon_fapiao@2x.png" alt="" class="icon_img" />
          <div class="font14 font_weight500 colo0">发票管理</div>
        </div>
        <div class="list_item" @click="showToast">
          <img src="@/assets/mine/icon_share@2x.png" alt="" class="icon_img" />
          <div class="font14 font_weight500 colo0">分享有礼</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goService() {
      this.$emit("goService");
    },
    showToast() {
      this.$toast("敬请期待");
    }
  }
};
</script>

<style lang="less" scoped>
.service_all {
  margin: 12px;
  background: #fff;
  border-radius: 6px;
  .top_info {
    padding: 8px 0;
    margin: 0 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.06);
  }
  .service_list {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 12px;
    .list_item {
      width: 33.33%;
      text-align: center;
      .icon_img {
        width: 36px;
        // display: block;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
